import { render, staticRenderFns } from "./NumeroBPI.vue?vue&type=template&id=6dd6f8db"
import script from "./NumeroBPI.vue?vue&type=script&lang=js"
export * from "./NumeroBPI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports